// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"f6e049f6","348":"5ef50991","422":"22f05f4f","864":"dd067949"}[chunkId] + ".chunk.js";
};